import {
	CalculatorDefaultResponse,
	CalculatorFormatedSummaries,
	CalculatorRequest,
} from '../hooks/calculator/useCalculator';
import { Oferta } from '../services/ofertas-service/models/ofertas';
import {
	extractCodeByCategory,
	extractUnderscore,
	getCO2Value,
	transformToSlashes,
} from './ofertas-helper';

export function getCondition(selectedOferta: Oferta): string {
	const combustible = selectedOferta.motor.combustible;
	let condition = '';

	switch (combustible) {
		case 'Eléctrico':
			condition = 'AQCL';
			break;
		case 'Híbrido enchufable':
			condition = 'AQCV';
			break;
		default:
			condition = 'AQBY';
			break;
	}

	return condition;
}

export function requestProducts(
	carlineConfiguration: any,
	selectedOferta: Oferta,
): CalculatorRequest | string {
	const request = {
		Request: {
			'@Domain': 'WEB.VW.ES',
			'Dealer': {
				ID: '0311Q',
			},
			'Vehicle': {
				'@Type': 'New',
				'Key': transformToSlashes(
					extractCodeByCategory(
						carlineConfiguration.configurations.content.consolidatedData
							.options,
						'TYPE',
					),
				),
				'Year': extractCodeByCategory(
					carlineConfiguration.configurations.content.consolidatedData.options,
					'MODELYEAR',
				),
				'PriceModel': selectedOferta.pff.basic,
				'PriceTotal':
					selectedOferta.pff.basic +
					selectedOferta.pff.accessory +
					selectedOferta.pff.exterior +
					selectedOferta.pff.package,
			},
		},
	};

	return request;
}

export function financeRequest(
	carlineConfiguration: any,
	selectedOferta: Oferta,
	productID: string | undefined,
): CalculatorRequest | string {
	const defaultProductConfig = {
		'@ID': productID,
		'Parameter': [
			{
				'@ID': 'DownPayment',
				'#text': selectedOferta.cuotaEntrada,
			},
			{
				'@ID': 'Duration',
				'#text': selectedOferta.plazos,
			},
			{
				'@ID': 'Mileage',
				'#text': '10000',
			},
			{
				'@ID': 'Condition',
				'#text': getCondition(selectedOferta),
			},
		],
	};

	const product = carlineConfiguration.productConfig ?? defaultProductConfig;

	const request = {
		Request: {
			'@Name': 'Defaults',
			'@Domain': 'WEB.VW.ES',
			'Product': product,
			'Dealer': {
				ID: '0311Q',
			},
			'Vehicle': {
				'@Type': 'New',
				'DiscountAmount': selectedOferta.pff.campaign,
				'Key': transformToSlashes(
					extractCodeByCategory(
						carlineConfiguration.configurations.content.consolidatedData
							.options,
						'TYPE',
					),
				),
				'Year': extractCodeByCategory(
					carlineConfiguration.configurations.content.consolidatedData.options,
					'MODELYEAR',
				),
				'PriceModel': selectedOferta.pff.basic,
				'PriceTotal':
					selectedOferta.pff.basic +
					selectedOferta.pff.accessory +
					selectedOferta.pff.exterior +
					selectedOferta.pff.package,
				'SalesgroupKey': extractCodeByCategory(
					carlineConfiguration.configurations.content.consolidatedData.options,
					'SALESGROUP',
				),
				'CarlineKey': extractUnderscore(
					carlineConfiguration.configurations.content.consolidatedData
						.model_code,
				),
				'Version': extractCodeByCategory(
					carlineConfiguration.configurations.content.consolidatedData.options,
					'VERSION',
				),
				'Options': {
					Option: [
						{
							'@ID': extractCodeByCategory(
								carlineConfiguration.configurations.content.consolidatedData
									.options,
								'COLOR_EXTERIEUR',
							),
							'@Code': extractCodeByCategory(
								carlineConfiguration.configurations.content.consolidatedData
									.options,
								'COLOR_EXTERIEUR',
							),
							'@Type': 'Exterior',
							'@Price': selectedOferta.pff.exterior,
						},
						{
							'@ID': 'YYY',
							'@Code': 'YYY',
							'@Type': 'Package',
							'@Price': selectedOferta.pff.package,
						},
						{
							'@ID': 'ZZZ',
							'@Code': 'ZZZ',
							'@Type': 'Accessory',
							'@Price': selectedOferta.pff.accessory,
						},
					],
				},
				'AditionalCosts': {
					AditionalCost: [
						{
							'@Type': 'REGISTRATION',
							'@Price': '0',
						},
					],
				},

				'TechInfos': {
					WltpData: {
						CO2Values: {
							CO2Value: [
								{
									'@Type': 'WLTP',
									'#text': getCO2Value(
										carlineConfiguration.configurations.content.consolidatedData
											.wltp_data.interpolations,
										selectedOferta.motor.combustible,
									),
								},
							],
						},
						//WheelDimensions: '245/45 R18 96W',
					},
				},
			},
		},
	};
	console.log(request);
	return request;
}

export function formatSummaries(
	response: CalculatorDefaultResponse['rawResponse'],
): CalculatorFormatedSummaries | undefined {
	const Summaries = response?.Response?.Result?.Summaries?.Summary.reduce(
		(acc: any, detail: any) => {
			acc[detail['@Type']] = detail;
			return acc;
		},
		{},
	);

	if (!Summaries) return undefined;

	Object.keys(Summaries).forEach((key) => {
		const summary = Summaries[key];
		const details = summary?.DetailGroups?.DetailGroup?.Details?.Detail;

		if (details) {
			const detailsArray = Array.isArray(details) ? details : [details];
			Summaries[key] = detailsArray.reduce((acc, detail) => {
				acc[detail['@ID']] = detail;
				return acc;
			}, {});
		}
	});

	return Summaries;
}
